import { Component, OnInit } from '@angular/core';
import { NgxSmartModalService, NgxSmartModalComponent } from 'ngx-smart-modal';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-project-modal-gravellog-remove',
  templateUrl: './project-modal-gravellog-remove.component.html',
  styleUrls: ['./project-modal-gravellog-remove.component.css']
})
export class ProjectModalGravellogRemoveComponent implements OnInit {

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    private toastr: ToastrService,
    private http: HttpClient
  ) { }

  api : string = '/api/gravellog/'
  modalName: string = 'projectModalGravellogRemove'
  id: number
  title: string = 'Ta bort gruslogg'
  text: string = 'Vill du verkligen ta bort grusloggen?'
  successMessage: string = 'Grusloggen har tagits bort.'
  errorMessage: string = 'Det gick inte att ta bort grusloggen.'

  clear(): void {
    this.id = null
    this.ngxSmartModalService.get(this.modalName).removeData()
  }

  close(): void {
    this.ngxSmartModalService.close(this.modalName)
  }

  remove(): void {
    this.http.delete<any>(this.api + "delete?id=" + this.id)
      .subscribe(
        () => {
          this.toastr.success(this.successMessage);
          this.ngxSmartModalService.get(this.modalName).removeData();
          this.ngxSmartModalService.setModalData({ success: true }, this.modalName);
          this.ngxSmartModalService.close(this.modalName);
        },
        (error) => {
          this.toastr.error(this.errorMessage);
        },
        () => {
          //complete
        }
      );
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.ngxSmartModalService.getModal(this.modalName).onOpen.subscribe((modal: NgxSmartModalComponent) => {
      this.id = modal.getData()
    });
  }

}
